/**
 * Shared utility strings for the two shapes that appear over and over in the
 * HeyAllergy funnel. Keeping them in one place is what stops the distinctive
 * 1.5px border and the hover/selected treatment drifting between components.
 *
 * `Docs/_parity/design-tokens.md` §7.3 and §7.5.
 */

/**
 * The funnel's signature field border: 1.5px, not 1px, not 2px.
 * Expressed as an arbitrary property because Tailwind's `border-<n>` utilities are
 * numeric and would not accept a token; this keeps the width in `theme.css`.
 */
export const FIELD_BORDER = 'border-solid [border-width:var(--border-field)] border-neutral-200';

/**
 * Every selectable surface (date chip, time slot, appointment type, secondary button)
 * is white with the field border at rest and gains a blue border on hover.
 */
export const SELECTABLE_REST =
  'bg-surface text-ink transition-all duration-150 hover:border-primary-hover';

/** Fields grow a blue border and the soft 12%-alpha ring on focus (§7.3). */
export const FIELD_FOCUS = 'focus:border-primary focus:shadow-focus';
